/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * API specification of EventGroupsAPI
 *
 * @class EventGroupsAPISpec
 * @private
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				const getAddToPreviousGroupActions = (contentIds) => {
					// organize the contentIds by groupId
					const contentIdsByGroupId = {};
					contentIds.forEach(contentId => {
						// obtain the groupId prior to the action
						const groupId = this.getGroupId(contentId);
						if (!contentIdsByGroupId[groupId]) {
							contentIdsByGroupId[groupId] = [];
						}
						contentIdsByGroupId[groupId].push(contentId);
					});
					// create a undo actions for each groupId
					// to add back the contents to their previous groups
					const actions = [];
					const groupIds = Object.keys(contentIdsByGroupId);
					groupIds.forEach(groupId => {
						const contentIds = contentIdsByGroupId[groupId];
						const currentGroupContentIds = this.getContentIdList(groupId) || [];
						// if all the contents in the group are moving, the group will be deleted
						if (currentGroupContentIds.length === contentIds.length) {
							// a group needs to created in reverse
							actions.push({
								name: 'createGroup',
								params:[ contentIds ]
							});
						} else {
							actions.push({
								name: 'addToGroup',
								params:[ groupId, contentIds ]
							});
						}
					});
					return actions;
				};

				this.apiSpec = {
					name: 'EventGroups API',
					features: {
						'Dashboard.Transaction': this.features['Transaction']
					},
					events: {
						propagationInfo: {
							namespace: 'eventgroups',
							info: {
								supportsUndoRedo: true
							},
							callStack: {
								name: 'getFeature',
								params: ['EventGroups']
							}
						},
						actions: {
							/**
							 * @event EventGroupsAPI#change:create
							 */
							'createGroup': {
								eventName: 'create',
								getInfo: (args) => {
									return {
										contentIds: args[0],
										supportsUndoRedo: true
									};
								},
								getUndoActions: (args) => {
									return getAddToPreviousGroupActions(args[0]);
								},
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.features['Transaction']
							},
							/**
							 * @event EventGroupsAPI#change:add
							 */
							'addToGroup': {
								eventName: 'add',
								getInfo: (args) => {
									return {
										contentIds: args[1],
										supportsUndoRedo: true
									};
								},
								getUndoActions: (args) => {
									return getAddToPreviousGroupActions(args[1]);
								},
								autoCreateTransaction: true,
								transactionParamIndex: 2,
								transactionAPI: this.features['Transaction']
							},
							/**
							 * @event EventGroupsAPI#change:remove
							 */
							'removeFromGroup': {
								eventName: 'remove',
								getInfo: (args) => {
									return {
										contentIds: args[0],
										supportsUndoRedo: true
									};
								},
								getUndoActions: (args) => {
									return getAddToPreviousGroupActions(args[0]);
								},
								autoCreateTransaction: true,
								transactionParamIndex: 1,
								transactionAPI: this.features['Transaction']
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});
